export default __webpack_public_path__ + "static/media/empresa-de-mulheres.636748f3.png";